import { ArrowLeft, ArrowRight, ArrowUp } from 'lucide-react';
import { useState } from 'react';
import type { Copy } from '../i18n';

export function Onboarding({ copy, onComplete }: { copy: Copy; onComplete: () => void }) {
  const [step, setStep] = useState(0);
  const [leaving, setLeaving] = useState(false);
  const finish = () => { setLeaving(true); window.setTimeout(onComplete, 220); };

  return (
    <div className={`onboarding ${leaving ? 'leaving' : ''}`} role="dialog" aria-modal="true" aria-labelledby="tutorial-title" data-testid="onboarding">
      <button className="skip" type="button" onClick={finish}>{copy.skip}</button>
      <div className="tutorial-visual" aria-hidden="true">
        {step === 0 && <div className="gesture-demo vertical"><span className="mini-card">W</span><ArrowUp /></div>}
        {step === 1 && <div className="gesture-demo horizontal"><span className="mini-card">W</span><ArrowLeft /></div>}
        {step === 2 && <div className="related-demo"><b>Chernobyl</b><span>Pripyat</span><span>RBMK</span><span>Fukushima</span><ArrowUp /></div>}
        {step === 3 && <div className="depth-demo"><span>Chernobyl</span><ArrowRight/><span>Fukushima</span><ArrowRight/><span>Tsunami</span><ArrowLeft/></div>}
      </div>
      <div className="tutorial-copy">
        <span className="step-count">0{step + 1} / 04</span>
        <h2 id="tutorial-title">{copy.onboarding[step]?.[0]}</h2>
        <p>{copy.onboarding[step]?.[1]}</p>
      </div>
      <div className="tutorial-footer">
        <div className="tutorial-dots">{copy.onboarding.map((_, index) => <span key={index} className={index === step ? 'active' : ''} />)}</div>
        <button className="primary-button" type="button" onClick={() => step === 3 ? finish() : setStep((value) => value + 1)}>
          {step === 3 ? copy.start : copy.nextStep}<ArrowRight size={18}/>
        </button>
      </div>
    </div>
  );
}
